<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap justify-start>
          <v-flex xs12 sm12 md10 text-left>
            <span
              style="font-family:opensansregular;font-size:12px;color:#686868;"
              class="text-capitalize"
            >Snacks & Branded Foods</span>
            <v-icon size="15" color="#686868">mdi-chevron-right</v-icon>
            <span
              style="font-family:opensansregular;font-size:12px;color:#686868;"
              class="text-capitalize"
            >Breakfast Cereals</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex py-2 xs12 sm12 md12 lg12 xl12>
            <v-img src="./../../assets/images/a9.png" contain></v-img>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12>
            <v-layout px-2 pt-4 wrap>
              <v-flex text-left class="align-content-center">
                <span style="font-family:opensansbold;font-size:14px;color:#464646">Sort by</span>
              </v-flex>
              <v-flex text-left>
                <span style="font-family:opensansregular;font-size:12px;">Popularity</span>
                <v-progress-linear :value="50" :background-opacity="0" color="#63028F" height="2"></v-progress-linear>
              </v-flex>
              <v-flex text-left>
                <span style="font-family:opensansregular;font-size:12px;">Price - Low to High</span>
              </v-flex>
              <v-flex text-left>
                <span style="font-family:opensansregular;font-size:12px;">Price - High to Low</span>
              </v-flex>
              <v-flex text-left>
                <span style="font-family:opensansregular;font-size:12px;">Newest</span>
              </v-flex>
              <v-flex text-left>
                <span style="font-family:opensansregular;font-size:12px;">Discount</span>
              </v-flex>
              <v-flex md2 text-right>
                <span
                  style="font-family:opensanssemibold;font-size:12px;color:#464646"
                >Showing 10 of 10 items</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout py-2 wrap>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout v-for="(item,j) in 2" :key="j" px-2 wrap>
          <v-flex py-2 xs6 sm12 md3 lg2 v-for="(item,i) in products" :key="i">
            <v-card tile flat>
              <v-layout wrap justify-center>
                <v-flex xs2 text-center>
                  <v-card color="#F13F3F" flat>
                    <span style="font-family:opensanssemibold;font-size:12px;color:white">{{item.discountpercentage}} %</span>
                  </v-card>
                </v-flex>
                <v-flex></v-flex>
                <v-flex xs12>
                  <v-img :src="getImageURL(item.image)" :alt="item.image" height="70px" contain></v-img>
                </v-flex>
                <v-flex
                  @click="$router.push('/'+item.name)"
                  xs10
                  text-center
                  style="cursor:pointer;height:50px"
                >
                  <span
                    style="font-family:opensanssemibold;font-size:12px;color:#2D2D2D"
                  >{{item.name}}</span>
                </v-flex>
                <v-flex xs12 text-center>
                  <span
                    style="font-family:opensanssemibold;font-size:14px;color:#2D2D2D"
                  >{{item.sellingPrice}}</span>
                </v-flex>
                <v-flex xs12 text-center>
                  <span style="font-family:opensanssemibold;font-size:12px;color:#C6C6C6">
                    <s>{{item.originalPrice}}</s>
                  </span>
                </v-flex>
                <v-flex xs12 text-center>
                  <v-btn small outlined depressed :ripple="true" color="#dadada">
                    <v-icon style="font-size:14px;color:#393939">mdi-cart</v-icon>
                    <span
                      style="font-family:opensanssemibold;font-size:12px;color:#393939;"
                      class="text-capitalize px-1"
                    >&nbsp;Add to Cart</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      products: [
        {
          name: "Romanian Lettuce",
          sellingPrice: "35.00 / Kg",
          originalPrice: "40 / kg",
          image: "1.png",
        },
        {
          name: "Saffola Gold Edible Vegetable Blended 5kg",
          sellingPrice: "35.00 / Kg",
          originalPrice: "40 / kg",
          image: "2.png",
        },
        {
          name: "Cadbury Celebrati- ons Gift Pack 136.7 g",
          sellingPrice: "35.00 / Kg",
          originalPrice: "40 / kg",
          image: "3.png",
        },
        {
          name: "Lay's American Style Cream &...",
          sellingPrice: "35.00 / Kg",
          originalPrice: "40 / kg",
          image: "4.png",
        },
        {
          name: "Hershey's Cocoa Spread With...",
          sellingPrice: "35.00 / Kg",
          originalPrice: "40 / kg",
          image: "5.png",
        },
        {
          name: "Pears Pure & Gentle Soap with Natural..",
          sellingPrice: "35.00 / Kg",
          originalPrice: "40 / kg",
          image: "6.png",
        },
        // {
        //   name: "Bagrry's Original & Healthier Cornflakes",
        //   sellingPrice: "35.00 / Kg",
        //   originalPrice: "40 / kg",
        //   image: "7.png",
        // },
      ],
    };
  },
  methods: {
    getImageURL(src) {
      var images = require.context("./../../assets/images/");
      return images("./" + src);
    },
  },
};
</script>